// import developImg from "../../Img/jobPage/develop.png";
// import defaultImg from "../../Img/jobPage/default.png";
// export const list = [
//   {
//     id: 1,
//     position: "개발",
//     type: "정규직 • 경력",
//     team: "",
//     duty: "유니티 게임 클라이언트 개발자",
//     sort: "Game",
//     img: developImg,
//     explain: "Unity를 이용한 모바일 게임 클라이언트 개발",
//     tag: ["Unity", "C#", "개임개발", "클라이언트", "3D"],
//     RS: [
//       {
//         id: 1,
//         title: "Unity를 이용한 모바일 게임 클라이언트 개발",
//         contents: [
//           "Unity를 활용한 모바일 게임 컨텐츠 개발",
//           "게임 개발에 필요한 구조 설계 및 개발",
//           "API 구조 개발 및 서버와 클라이언트간 통신 구현",
//         ],
//       },
//       // {
//       //   id: 2,
//       //   title: "하이퍼 캐주얼 장르의 간단한 기획",
//       //   contents: [
//       //     "하이퍼 캐주얼 장르에 관한 전반적인 R&D",
//       //     "진행 프로젝트의 스테이지 제작 및 콘텐츠 개발",
//       //   ],
//       // },
//     ],
//     MQ: [
//       "3년 이상의 게임 프로젝트 개발 경험이 있으신 분",
//       "Git을 사용하여 동료 개발자와 공동 개발에 어려움이 없으신 분",
//       "Unity 및 C#에 대한 지식을 바탕으로 효율적인 코드 작성이 가능하신 분",
//       "논리적 의사소통 및 문제해결 능력을 기반으로 협업에 무리가 없으신 분",
//     ],
//     PQ: [
//       "AWS를 활용하여 게임 제작 경험이 있으신 분",
//       "게임 출시 이후 라이브 서비스 경험이 있으신 분",
//     ],
//     DC: [
//       "간단한 자기소개가 포함된 이력서 (자유양식)",
//       "코드가 포함된 포트폴리오(저작권 등 법적 문제가 없고 직접 작성한 코드 포함)",
//     ],
//     OHP: [
//       "서류 전형 > 1차 인터뷰(기술) > 2차 인터뷰 > 수습 기간(3개월) > 정규직 입사",
//     ],
//     form: "고용 형태 : 수습 기간 3개월 이후 정규직 평가(해당 기간 중 급여 100% 지급)",
//   },
//   {
//     id: 2,
//     position: "디자인",
//     type: "정규직 • 경력",
//     team: "",
//     duty: "UI 디자이너",
//     img: defaultImg,
//     explain: "포토샵 / 일러스트를 이용한 UI 제작",
//     tag: ["UI/UX", "GUI", "UI 디자인", "Art", "Unity"],
//     sort: "Game",
//     RS: [
//       {
//         id: 1,
//         title: "포토샵 / 일러스트를 이용한 UI 제작",
//         contents: [
//           "UI 디자인 리소스 제작",
//           "게임에 대한 이해를 바탕으로 UX 설계",
//         ],
//       },
//       // {
//       //   id: 2,
//       //   contents: [
//       //     "하이퍼 캐주얼 장르의 간단한 게임 기획 및 디자인 컨셉 구상",
//       //     "하이퍼 캐주얼 게임의 글로벌 트렌드 파악",
//       //     "하이퍼 캐주얼 시장 디자인 트렌드 분석 및 적용",
//       //   ],
//       // },
//     ],
//     MQ: [
//       "3년 이상의 UI 디자인 경력이 있으신 분",
//       "다양한 컨셉의 드로잉 경험으로 UI 리소스를 제작하는데 무리가 없으신 분",
//       "게임에 대한 이해를 바탕으로 레이아웃 설계가 가능하신 분",
//       "논리적 의사소통 및 문제해결 능력을 기반으로 협업에 무리가 없으신 분",
//     ],
//     PQ: ["Unity 엔진에 UI 리소스 적용이 가능하신 분"],
//     DC: [
//       "간단한 자기소개가 포함된 이력서 (자유양식)",
//       "작업물이 포함된 포트폴리오(저작권 등 법적 문제가 없고, 직접 작업한 작업물만 포함)",
//     ],
//     OHP: [
//       "서류 전형 > 과제 전형 > 1차 인터뷰 > 수습 기간(3개월) > 정규직 입사",
//     ],
//     form: "고용 형태 : 수습 기간 3개월 이후 정규직 평가(해당 기간 중 급여 100% 지급)",
//   },
//   {
//     id: 3,
//     position: "디자인",
//     type: "정규직 • 경력무관",
//     team: "",
//     duty: "2D 모바일 게임 아티스트",
//     img: defaultImg,
//     explain: "모바일 게임 2D 아트 리소스 제작",
//     tag: ["Unity", "Art", "2D", "UI디자인", "캐릭터디자인"],
//     sort: "Game",
//     RS: [
//       {
//         id: 1,
//         title: "모바일 게임 2D 아트 리소스 제작",
//         contents: [
//           "2D 모바일 게임 내 캐릭터 및 배경을 포함한 아트 리소스 제작",
//           "Unity 툴을 이용하여 캐릭터 애니메이션 제작",
//           "간단한 UI 레이아웃 설계 및 디자인",
//         ],
//       },
//       // {
//       //   id: 2,
//       //   contents: [
//       //     "하이퍼 캐주얼 장르의 간단한 게임 기획 및 디자인 컨셉 구상",
//       //     "하이퍼 캐주얼 게임의 글로벌 트렌드 파악",
//       //     "하이퍼 캐주얼 시장 디자인 트렌드 분석 및 적용",
//       //   ],
//       // },
//     ],
//     MQ: [
//       "Unity 엔진을 활용하여 게임 제작 경험이 있으신 분",
//       "다양한 컨셉의 드로잉 경험을 통해 캐주얼한 아트 리소스를 제작하는데 무리가 없으신 분",
//       "논리적 의사소통 및 문제해결 능력을 기반으로 하여 협업에 무리가 없으신 분",
//     ],
//     PQ: [
//       "2D 게임 아트 분야에서 3년이상 실무 경험이 있으신분",
//       "아티스트로서 게임 제작 초기 단계의 컨셉 아트부터 라이브 서비스까지의 경험이 있으신 분",
//       "Unity 파티클 시스템을 이용하여 연출 제작 경험이 있으신분",
//     ],
//     DC: [
//       "간단한 자기소개가 포함된 이력서 (자유양식)",
//       "포트폴리오(저작권 등 법적 문제가 없고, 직접 작업한 작업물만 포함)",
//     ],
//     OHP: [
//       "서류 전형 > 과제 전형 > 1차 인터뷰 > 수습 기간(3개월) > 정규직 입사",
//     ],
//     form: "고용 형태 : 수습 기간 3개월 이후 정규직 평가(해당 기간 중 급여 100% 지급)",
//   },
//   // {
//   //   id: 3,
//   //   position: "경영지원",
//   //   type: "정규직 • 경력",
//   //   img: defaultImg,
//   //   team: "[HR]",
//   //   duty: `채용 ${"/"} 인사운영 담당자`,
//   //   explain: "인재 리크루팅 및 사내 HR 관리, 조직문화 구성",
//   //   tag: ["HR", "인사운영", "경영지원", "조직문화", "리크루팅"],
//   //   sort: "HR",

//   //   RS: [
//   //     {
//   //       id: 1,
//   //       contents: [
//   //         "인재 채용",
//   //         "직무별 필요 요건 및 자격을 기준으로 하여 적합한 인재 채용",
//   //         "다양한 채널로 인재 네트워킹을 통해 채용 후보자 확보",
//   //         "회사의 성장 페이즈에 맞는 필요 인력풀을 캐치하여 채용 제안",
//   //         "인재 채용에 관한 전반적인 업무",
//   //       ],
//   //     },
//   //     {
//   //       id: 2,
//   //       contents: [
//   //         "조직 문화 정비 및 인사 제도 정립",
//   //         "HR 제도 운영 및 기획",
//   //         "회사의 업무 프로세스 및 인사 제도의 개선사항을 고민하여 지속적인 사내 문화 개선",
//   //         "사내 구성원들이 업무에만 집중하여 최고의 성과를 낼 수 있도록 지원할 수 있는 다양한 방향성 제시",
//   //       ],
//   //     },
//   //   ],
//   //   MQ: [
//   //     "채용 혹은 HR관리 관련 업무 경력 3년 이상인 분",
//   //     "소싱 플랫폼(Linked-in, 잡코리아 등)을 통해 직접 인재 영입의 경험이 있으신 분",
//   //     "사내 조직문화 및 인사체계 수립 관련 업무 경험이 있으신 분",
//   //     "능동적인 의사소통과 긍정적인 태도로 대인관계 형성에 탁월하신 분",
//   //     "채용 트렌드 및 채용 직무별 필요 역량, 평가 문항 등 채용시장에 대해 꾸준한 관심을 가지고 공부하시는 분",
//   //   ],
//   //   PQ: [
//   //     "초기 단계의 스타트업 HR팀에서 근무한 경력이 있으신 분",
//   //     "IT/게임 산업에 대한 이해도가 높으신 분",
//   //     "외국인 채용 및 인사 관리 경험이 있으신 분",
//   //     "영어를 통한 의사소통에 문제가 없으신 분",
//   //   ],
//   //   DC: [
//   //     "간단한 자기소개가 포함된 이력서 (자유양식)",
//   //     "지원 동기 및 MondayOFF에서 하고싶은 R&R 기술서",
//   //   ],
//   //   OHP: [
//   //     "서류전형 > 면접 > 수습 기간(3개월의 수습기간, 해당 기간 중 급여 100% 지급) > 정규직 전환",
//   //   ],
//   //   form: "수습 3개월 기간 이후 정규직 전환(해당 기간 중 급여 100% 지급)",
//   // },

//   // {
//   //   id: 4,
//   //   position: "경영지원",
//   //   type: "정규직 • 경력",
//   //   team: "[회계]",
//   //   duty: "회계 담당자",
//   //   sort: "Money",
//   //   img: defaultImg,
//   //   explain: "회계업무 전반, 부가세 신고 및 결산",
//   //   tag: ["회계", "비용처리", "부가세", "회계감사", "회계실사"],
//   //   RS: [
//   //     {
//   //       id: 1,
//   //       contents: [
//   //         "더존 Smart A를 사용하여 월/분기/연 회계결산",
//   //         "매출 및 비용 증빙자료 정리, 회계장부 관리",
//   //         "분기별 부가세 및 각종 세무 신고 자료 정리",
//   //         "4대보험 및 퇴직연금 관리",
//   //         "연말 회계 감사 및 필요 시점에 회계 실사 업무 지원",
//   //       ],
//   //     },
//   //   ],
//   //   MQ: [
//   //     "유관업무 경력 1년 이상이신 분",
//   //     "ERP 사용 및 회계 관련 엑셀 시트 작성에 무리가 없으신 분",
//   //     "업무 관계자와 논리적인 의사소통이 뛰어나신 분",
//   //   ],
//   //   PQ: [
//   //     "기업의 회계감사 혹은 실사 경험이 있으신 분",
//   //     "초기 단계의 스타트업 회계팀에서 근무한 경력이 있으신 분",
//   //     "영어 문서 혹은 메일을 읽는데 무리가 없으신 분",
//   //   ],
//   //   DC: ["간단한 자기소개가 포함된 이력서 (자유양식)", "경력기술서"],
//   //   OHP: [
//   //     "서류전형 > 면접 > 수습 기간(3개월의 수습기간, 해당 기간 중 급여 100% 지급) > 정규직 전환",
//   //   ],
//   //   form: "수습 3개월 기간 이후 정규직 전환(해당 기간 중 급여 100% 지급)",
//   // },

//   // {
//   //   id: 6,
//   //   position: "개발",
//   //   type: "정규직 • 경력",
//   //   team: "[퍼블리싱 대시보드 개발]",
//   //   duty: "Back-end 개발자",
//   //   sort: "Server",
//   //   img: developImg,
//   //   explain: "Node.js를 활용한 Back-end 서버 개발",
//   //   tag: ["Node.js", "Javascript", "Express", "RDBMS", "Nginx"],
//   //   RS: [
//   //     {
//   //       id: 1,
//   //       contents: [
//   //         "Node.js를 활용한 Back-end 서버 개발",
//   //         "기존 서비스의 유지 보수 및 신규 서비스 개발",
//   //       ],
//   //     },
//   //   ],
//   //   MQ: [
//   //     "Javascript에 대한 이해가 깊으신 분",
//   //     "Node.js, Express등의 프레임워크를 이용한 개발 경험이 있으신 분",
//   //     "Git을 이용한 버전 관리 사용 경험이 있으신 분",
//   //     "효율적인 아키텍처 설계에 관심이 많으신 분",
//   //     "논리적인 사고로 원활한 의사소통이 가능하신 분",
//   //   ],
//   //   PQ: [
//   //     "개발과 관련된 영어 문서를 읽을 수 있는 능력",
//   //     "RDBMS 설계 및 운용 경험",
//   //     "Nginx 등 서버 운영 경험",
//   //   ],
//   //   DC: [
//   //     "간단한 자기소개가 포함된 이력서 (자유양식)",
//   //     "수행한 프로젝트 위주의 포트폴리오 (포트폴리오엔 본인의 역할이 모두 기재되어 있어야 합니다.)",
//   //   ],
//   //   OHP: [
//   //     "서류전형 > 면접 > 수습 기간(3개월의 수습기간, 해당 기간 중 급여 100% 지급) > 정규직 전환",
//   //   ],
//   //   form: "수습 3개월 기간 이후 정규직 전환(해당 기간 중 급여 100% 지급)",
//   // },
//   /*
//   {
//     id: 7,
//     position: "디자인",
//     type: "정규직 • 경력무관",
//     img: designImg,
//     team: "[디자인]",
//     duty: "콘텐츠 디자이너",
//     explain: "브랜드 방향성에 맞는 그래픽 이미지 제작",
//     tag: [
//       "그래픽디자인",
//       "Adobe",
//       "3D",
//       "마케팅디자인",
//       "콘텐츠디자인",
//       "브랜딩",
//     ],
//     sort: "Graphic",
//     RS: [
//       "글로벌 마케팅을 위한 다양한 이미지 제작",
//       "웹사이트를 위한 일관적인 컨셉의 다양한 그래픽 이미지 리소스 제작",
//       "다양한 SNS에 노출될 매력적인 이미지 제작",
//       "온/오프라인을 넘나드는 그래픽 이미지 제작",
//     ],
//     MQ: [
//       "다양한 스타일의 그래픽 이미지 제작이 가능하신 분",
//       "의도하고자 하는 아이디어를 구체화하고 효과적으로 구현해낼 수 있으신 분",
//       "트렌드에 민감하고 다양한 미디어에 친숙하신 분",
//       "원활한 의사소통이 가능하신 분",
//     ],
//     PQ: [
//       "영상 콘텐츠 제작이 가능하신 분",
//       "C4D, Blender등 3D이미지 제작 경험이 있으신 분",
//       "글로벌 경험 또는 외국어 커뮤니케이션 능력",
//       "항상 무언가를 배우고 배운 내용을 업무에 적용하고자 노력하시는 분",
//     ],
//     DC: [
//       "간단한 자기소개가 포함된 이력서 (자유양식)",
//       "수행한 프로젝트 위주의 포트폴리오 (포트폴리오엔 본인의 역할이 모두 기재되어 있어야 합니다.)",
//     ],
//     OHP: [
//       "서류전형 > 과제전형 > 면접 > 인턴십(3~6개월의 수습기간, 해당 기간 중 급여 100% 지급) > 정규직 입사",
//     ],
//     form: "고용 형태 : 인턴 3~6개월 기간 이후 정규직 평가(해당 기간 중 급여100% 지급)",
//   },
// */
//   // {
//   //   id: 8,
//   //   position: "사업/마케팅",
//   //   type: "정규직 • 경력무관",
//   //   img: defaultImg,
//   //   team: "[Creative팀]",
//   //   duty: "마케팅 영상 편집자",
//   //   explain: "하이퍼 캐주얼 홍보 영상 제작",
//   //   tag: ["프리미어", "애프터이펙트", "영상편집", "게임영상"],
//   //   sort: "Creative",
//   //   RS: [
//   //     {
//   //       id: 1,
//   //       contents: [
//   //         "하이퍼 캐주얼 홍보 영상 제작",
//   //         "영상 데이터 분석",
//   //         "하이퍼 캐주얼 마케팅 시장 R&D",
//   //       ],
//   //     },
//   //   ],
//   //   MQ: [
//   //     "프리미어/애프터 이펙트를 잘 다루시는 분",
//   //     "제작한 영상의 데이터 개선에 관한 적극적인 연구자세를 가지신 분",
//   //     "업무 관계자와 논리적인 의사소통이 뛰어나신 분",
//   //   ],
//   //   PQ: [
//   //     "평소 하이퍼 캐주얼 장르의 게임을 즐겨하시는 분",
//   //     "다양한 게임을 즐기고 게임 외에 다양한 콘텐츠도 많이 접해보신 분",
//   //     "항상 무언가를 배우고 배운 내용을 업무에 적용하고자 노력하시는 분",
//   //   ],
//   //   DC: [
//   //     "간단한 자기소개가 포함된 이력서 (자유양식)",
//   //     "수행한 프로젝트 위주의 포트폴리오",
//   //   ],
//   //   OHP: [
//   //     "서류전형 > 과제전형 > 면접 > 인턴십(3~6개월의 수습기간, 해당 기간 중 급여 100% 지급) > 정규직 입사",
//   //   ],
//   //   form: "고용 형태 : 인턴 3~6개월 기간 이후 정규직 평가(해당 기간 중 급여100% 지급)",
//   // },
//   // {
//   //   id: 9,
//   //   position: "사업/마케팅",
//   //   type: "Full time • Entry level works",
//   //   img: defaultImg,
//   //   team: "[Partnership department]",
//   //   duty: "Publishing manager",
//   //   explain: "Discover industry talent and help them grow their business",
//   //   tag: ["sales", "marketing", "Social network management", "data analysis"],
//   //   sort: "Publishing",
//   //   lo: "en",
//   //   RS: [
//   //     {
//   //       id: 1,
//   //       contents: [
//   //         "Build and lead close relationships with developers/studio partners worldwide",
//   //         "Manage the end-to-end production cycle of games with studio partners, including the development of game concepts, leading partners through the marketing test process and further iterations of their game prototype up to the game launch and beyond",
//   //         "Discover industry talent and help them grow their business",
//   //         "Contribute to our social media presence and promotion of our brand",
//   //         "Conduct market research and keep up with / identify new trends to contribute to game ideation phases",
//   //       ],
//   //     },
//   //   ],
//   //   MQ: [
//   //     "Advanced English Proficiency",
//   //     "Excellent international and intercultural communication skills",
//   //     "Customer focused and results oriented",
//   //     "Proactive, curious and innovative approach to problem solving with a constant improvement mindset",
//   //     "Ability to learn about and quickly adapt to the ever changing hypercasual industry",
//   //   ],
//   //   PQ: [
//   //     "Basic Korean communication skills",
//   //     "Basic communication skills in Turkish or Russian",
//   //     "Experience working with colleagues of various nationalities",
//   //   ],
//   //   DC: ["Resume (including Photo and Visa-type)", "Cover Letter"],
//   //   OHP: [
//   //     "Submit Application > Interview and Analytical Task > Internship (fully paid trainee period of 3-6 months)* > Full-Time Position",
//   //   ],
//   //   form: " Internship of 3-6 months, willingness/availability to continue working for more than 3-6 months if given a full-time offer after the intern period",
//   // },
//   // {
//   //   id: 10,
//   //   position: "사업/마케팅",
//   //   type: "Full time",
//   //   img: defaultImg,
//   //   team: "[Marketing Team]",
//   //   duty: "Monetization Manager",
//   //   explain:
//   //     "Managing substantial information about Monetization & UA strategy for being a global top publisher",
//   //   tag: ["Monetization", "marketing", "data analysis"],
//   //   sort: "Marketing",
//   //   lo: "en",
//   //   RS: [
//   //     {
//   //       id: 1,
//   //       contents: [
//   //         "Increase overall performance of default waterfall",
//   //         "Optimize waterfalls of each games to maximize user LTV",
//   //         "Test new monetization channels to expand ad fill rate",
//   //         "Explore new business models",
//   //       ],
//   //     },
//   //   ],
//   //   MQ: [
//   //     "Advanced English Proficiency",
//   //     "Need advanced analysis & organizing skill",
//   //   ],
//   //   PQ: [
//   //     "Excellent international and intercultural communication skills",
//   //     "Advanced communication skills in Korean",
//   //     "Advanced communication skills in Trilingual",
//   //   ],
//   //   DC: ["Resume (including Photo and Visa-type)", "Cover Letter"],
//   //   OHP: [
//   //     "Submit Application > Interview and Analytical Task > Internship (fully paid trainee period of 3-6 months)* > Full-Time Position",
//   //   ],
//   //   form: " Internship of 3-6 months, willingness/availability to continue working for more than 3-6 months if given a full-time offer after the intern period",
//   // },
//   // {
//   //   id: 11,
//   //   position: "사업/마케팅",
//   //   type: "Full time",
//   //   img: defaultImg,
//   //   team: "[Marketing Team]",
//   //   duty: "User Acquisition Manager",
//   //   explain:
//   //     "Managing substantial information about Monetization & UA strategy for being a global top publisher",
//   //   tag: ["UA", "marketing", "data analysis"],
//   //   sort: "Marketing",
//   //   lo: "en",
//   //   RS: [
//   //     {
//   //       id: 1,
//   //       contents: [
//   //         "As a UA Manager, you will handle some of the following tasks:",
//   //         "Analyze and make decisions on ROI at an early stage.",
//   //         "Execute scale-up campaigns plan for every new game.",
//   //         "Manage live campaigns to improve ROAS",
//   //         "Improve UA strategy by keeping track of the latest market trend.",
//   //         "Test and explore new marketing channels and ROI.",
//   //       ],
//   //     },
//   //   ],
//   //   MQ: [
//   //     "Advanced English Proficiency",
//   //     "Need advanced analysis & organizing skill",
//   //   ],
//   //   PQ: [
//   //     "Excellent international and intercultural communication skills",
//   //     "Advanced communication skills in Korean",
//   //     "Advanced communication skills in Trilingual",
//   //   ],
//   //   DC: ["Resume (including Photo and Visa-type)", "Cover Letter"],
//   //   OHP: [
//   //     "Submit Application > Interview and Analytical Task > Internship (fully paid trainee period of 3-6 months)* > Full-Time Position",
//   //   ],
//   //   form: " Internship of 3-6 months, willingness/availability to continue working for more than 3-6 months if given a full-time offer after the intern period",
//   // },
//   {
//     id: 12,
//     position: "개발",
//     type: "정규직 • 경력",
//     team: "",
//     duty: "게임 서버 프로그래머",
//     img: defaultImg,
//     explain: "게임 서버 구축",
//     tag: ["C#", "AWS", "게임서버", "백엔드", "ASP.NET Core", "MongoDB"],
//     sort: "Game",
//     RS: [
//       {
//         id: 1,
//         title: "게임 서버 구축",
//         contents: [
//           "게임 클라이언트와 통신 가능한 API 구조 설계 및 개발",
//           "서버 인프라 구축 및 관리",
//           "서버 장애 대응 및 전반적인 구조 보완 및 개선",
//         ],
//       },
//       // {
//       //   id: 2,
//       //   contents: [
//       //     "하이퍼 캐주얼 장르의 간단한 게임 기획 및 디자인 컨셉 구상",
//       //     "하이퍼 캐주얼 게임의 글로벌 트렌드 파악",
//       //     "하이퍼 캐주얼 시장 디자인 트렌드 분석 및 적용",
//       //   ],
//       // },
//     ],
//     MQ: [
//       "백엔드 개발 경력 3년 이상이신 분",
//       "C#을 이용한 게임 웹서버 구축 및 개발 경험이 있으신 분",
//       "AWS 클라우드 사용 경험이 있으신 분",
//     ],
//     PQ: [
//       "ASP.NET Core, MongoDB 활용 경험이 있으신 분",
//       "게임 내 데이터베이스 설계 및 관리 경험이 있으신 분",
//       "실시간 서버 베이스의 게임 개발 경험이 있으신 분",
//       "게임 출시 이후 라이브 서비스 경험이 있으신 분",
//     ],
//     DC: [
//       "간단한 자기소개가 포함된 이력서 (자유양식)",
//       "코드가 포함된 포트폴리오(저작권 등 법적 문제가 없고, 직접 작업한 작업물만 포함)",
//     ],
//     OHP: [
//       "서류 전형 > 1차 인터뷰(기술) > 2차 인터뷰 > 수습 기간(3개월) > 정규직 입사",
//     ],
//     form: "고용 형태 : 수습 기간 3개월 이후 정규직 평가(해당 기간 중 급여 100% 지급)",
//   },
//   {
//     id: 13,
//     position: "개발",
//     type: "정규직 • 경력무관",
//     team: "",
//     duty: "플레이어블 애즈 개발자",
//     img: defaultImg,
//     explain: "플레이어블 애즈(플레이가 가능한 형태의 광고) 개발",
//     tag: ["Playable Ads", "HTML5", "JavaScript", "CSS", "Cocos Creator"],
//     sort: "Game",
//     RS: [
//       {
//         id: 1,
//         title: "플레이어블 애즈(플레이가 가능한 형태의 광고) 개발",
//         contents: [
//           "HTML5 / JavaScript / CSS기반의 플레이어블 애즈 개발",
//           "광고 매체별 포맷(용량 등)에 맞추어 HTML5 파일 생성",
//           "크리에이티브팀(광고 소재 제작팀)과의 소통을 통한 광고 성과 개선 작업 수행",
//         ],
//       },
//       // {
//       //   id: 2,
//       //   contents: [
//       //     "하이퍼 캐주얼 장르의 간단한 게임 기획 및 디자인 컨셉 구상",
//       //     "하이퍼 캐주얼 게임의 글로벌 트렌드 파악",
//       //     "하이퍼 캐주얼 시장 디자인 트렌드 분석 및 적용",
//       //   ],
//       // },
//     ],
//     MQ: [
//       "Cocos Creator등 HTML5 형태의 인터랙티브 콘텐츠/게임 개발 경험이 있으신 분",
//       "논리적 의사소통 및 문제해결 능력을 기반으로 하여 협업에 무리가 없으신 분",
//     ],
//     PQ: [
//       "상용화된 플레이어블 애즈 제작 경험이 있으신 분",
//       "팀 단위 프로젝트에서 마케팅팀, 광고 소재 제작팀 등 타 팀과의 협업 경험이 있으신 분",
//     ],
//     DC: [
//       "간단한 자기소개가 포함된 이력서 (자유양식)",
//       "코드가 포함된 포트폴리오(저작권 등 법적 문제가 없고, 직접 작업한 작업물만 포함)",
//     ],
//     OHP: [
//       "서류 전형 > 과제 전형 > 1차 인터뷰 > 수습 기간(3개월) > 정규직 입사",
//     ],
//     form: "고용 형태 : 수습 기간 3개월 이후 정규직 평가(해당 기간 중 급여 100% 지급)",
//   },
// ];

export const list = [];
